
import { _destructureProxy } from '../miscellaneous/proxies';

export const createSignature = fullName => {

    if(!window.Proxy) {
        const {
            firstName,
            middleName,
            lastName,
            suffix
        } = fullName;

        return [
            `${firstName} ${lastName}`,
            `${firstName} ${middleName} ${lastName}`,
            `${firstName} ${middleName} ${lastName} ${suffix}`,
            `${firstName} ${lastName} ${suffix}`,
        ];
    }

    return new window.Proxy(fullName => {
        const {
            firstName,
            middleName,
            lastName,
            suffix
        } = _destructureProxy(fullName);

        return [
            `${firstName} ${lastName}`,
            `${firstName} ${middleName} ${lastName}`,
            `${firstName} ${middleName} ${lastName} ${suffix}`,
            `${firstName} ${lastName} ${suffix}`,
        ];
    }, {
        apply: (target, thisArg, argsList) => {
            if(Array.isArray(fullName) || typeof fullName !== 'object' || fullName === null) {
                throw new Error('Not an object has been passed to createSignature');
            }
            return Reflect.apply(target, thisArg, argsList);
        }
    })(fullName);
};

